import {SortType} from "../constants/CreditOffersSortOptions";
import {ICreditOffer} from "../types/ICreditOffer";

export const sortCreditOffers = (offers: ICreditOffer[], type: SortType) => {
    const offersToSort = offers.filter((offer) => offer.fixed_interest_rate_percent > 0);

    switch (type) {
        case SortType.PERCENT_DOWN:
            return offersToSort.sort((prev, next) => next.fixed_interest_rate_percent - prev.fixed_interest_rate_percent);
        case SortType.PERCENT_UP:
            return offersToSort.sort((prev, next) => prev.fixed_interest_rate_percent - next.fixed_interest_rate_percent);
        case SortType.RRSO_DOWN:
            return offersToSort.sort((prev, next) => next.rrso - prev.rrso);
        case SortType.RRSO_UP:
            return offersToSort.sort((prev, next) => prev.rrso - next.rrso);
        case SortType.COMMISSION_DOWN:
            return offersToSort.sort((prev, next) => next.commission - prev.commission);
        case SortType.COMMISSION_UP:
            return offersToSort.sort((prev, next) => prev.commission - next.commission);
        case SortType.COSTS:
            return offersToSort.sort((prev, next) => prev.all_costs_sum - next.all_costs_sum);
        case SortType.INSTALMENT_RATE:
        default:
            return offersToSort.sort((prev, next) => prev.equal_installment_rate - next.equal_installment_rate);
    }
};
import {SortType} from "../constants/CreditOffersSortOptions";
import {ICreditOffer} from "../types/ICreditOffer";

export const sortCreditOffers = (offers: ICreditOffer[], type: SortType) => {
    const offersToSort = offers.filter((offer) => offer.fixed_interest_rate_percent > 0);

    switch (type) {
        case SortType.PERCENT_DOWN:
            return offersToSort.sort((prev, next) => next.fixed_interest_rate_percent - prev.fixed_interest_rate_percent);
        case SortType.PERCENT_UP:
            return offersToSort.sort((prev, next) => prev.fixed_interest_rate_percent - next.fixed_interest_rate_percent);
        case SortType.RRSO_DOWN:
            return offersToSort.sort((prev, next) => next.rrso - prev.rrso);
        case SortType.RRSO_UP:
            return offersToSort.sort((prev, next) => prev.rrso - next.rrso);
        case SortType.COMMISSION_DOWN:
            return offersToSort.sort((prev, next) => next.commission - prev.commission);
        case SortType.COMMISSION_UP:
            return offersToSort.sort((prev, next) => prev.commission - next.commission);
        case SortType.COSTS:
            return offersToSort.sort((prev, next) => prev.all_costs_sum - next.all_costs_sum);
        case SortType.INSTALMENT_RATE:
        default:
            return offersToSort.sort((prev, next) => prev.equal_installment_rate - next.equal_installment_rate);
    }
};
